import React from 'react';
import { Mic } from 'lucide-react';
import { podcastEpisodesAPI } from '../../lib/api';
import MediaContentManager from '../../components/admin/MediaContentManager';

const formatDuration = (s) => {
  const total = Number(s) || 0;
  if (!total) return null;
  const m = Math.floor(total / 60);
  return m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${m} min`;
};

const config = {
  title: 'Podcasts',
  description: 'Audio episodes for the Podcasts section on the website and in the apps.',
  noun: 'episode',
  icon: Mic,
  api: podcastEpisodesAPI,
  audioField: 'audio_url',
  thumbnail: (p) => p.artwork_url || null,
  subtitle: (p) => [p.host, p.category, `S${p.season || 1} · E${p.episode || 1}`, formatDuration(p.duration_seconds)].filter(Boolean).join(' · '),
  fields: [
    { name: 'title', label: 'Title', required: true },
    {
      name: 'audio_url', label: 'Audio file', required: true, placeholder: 'https://…/episode.mp3', upload: 'audio/*',
      help: 'Upload an MP3/M4A (up to 50 MB) or paste a link to one.',
      validate: (v) => (/^https?:\/\//.test(v || '') ? null : 'Audio must be an uploaded file or a full https link'),
    },
    { name: 'artwork_url', label: 'Artwork', placeholder: 'https://…/cover.jpg', upload: 'image/*', help: 'Square image, at least 1400×1400 looks best.' },
    { name: 'host', label: 'Host', default: 'Neural News' },
    { name: 'category', label: 'Category', default: 'General' },
    { name: 'season', label: 'Season', type: 'number', default: 1 },
    { name: 'episode', label: 'Episode', type: 'number', default: 1 },
    { name: 'duration_seconds', label: 'Length (seconds)', type: 'number', default: 0, help: 'Optional. 1800 = 30 minutes.' },
    { name: 'description', label: 'Show notes', type: 'textarea' },
  ],
};

export default function AdminPodcasts() {
  return <MediaContentManager config={config} />;
}
